import { SimpleResponse } from 'Types/simpleResponse'
import { RequestParams, ResponseCatalog } from 'Models'
import { urls } from 'Constants/Urls'
import { axiosDS } from '@pp/axios'
import { BgBlackList, CreateBgBlackListItem } from 'Pages/ibro'

export const bgBlackListApi = {
	getBlackList: async (params: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<BgBlackList>>(urls.broker.black_list, {
			params,
		})
		return res.data
	},

	createBlackList: async (data: CreateBgBlackListItem) => {
		const res = await axiosDS().post<BgBlackList>(urls.broker.black_list, { data })
		return res.data
	},

	updateBlackList: async (data: BgBlackList) => {
		const res = await axiosDS().patch<BgBlackList>(`${urls.broker.black_list}/${data.id}`, { data })
		return res.data
	},

	deleteBlackList: async (id: number) => {
		const res = await axiosDS().delete<SimpleResponse>(`${urls.broker.black_list}/${id}`)
		return res.data
	},
}
